import React from "react";

export const LangDirectionContext = React.createContext();
